import React, { createContext, useEffect, useState } from "react";
import { useLocalStorage } from "../Hooks/useLocalStorage";

export const Context = createContext();

const Provider = ({ children, data }) => {
  const ls = useLocalStorage();
  const [user, setUser] = useState(() => {
    return ls.getJSON("user") ? ls.getJSON("user") : null;
  });
  const [cartProducts, addCartProducts] = useState(() => {
    return ls.getJSON("cartProducts") ? ls.getJSON("cartProducts") : [];
  });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [productsLoading, setProductsLoading] = useState(true);
  const [firstRender, isFirstRender] = useState(true);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState(() => ls.getJSON('products') ? ls.getJSON('products') : []);
  const [domain, setDomain] = useState(data);
  const [langRefreshKey, setLangRefreshKey] = useState(0);

  useEffect(() => {
    if (data) {
      setDomain(data);
    }
  }, [data]);

  const value = {
    user,
    setUser: (data) => {
      setUser(data);
      ls.setJSON("user", data);
    },
    domain,
    setDomain,
    logout: () => {
      setUser(null);
      ls.remove("user");
    },
    addCartProducts: (data) => {
      const incoming = data.product;
      let foundIndex = -1;

      for (let i = 0; i < cartProducts.length; i++) {
        const existing = cartProducts[i].product;

        if (existing.id !== incoming.id) continue;

        if (existing.type === "variable" && existing.variation && incoming.variation) {
          if (existing.variation.id !== incoming.variation.id) continue;
        } else if (existing.type !== incoming.type) {
          continue;
        }

        if (
          (existing.type === "grouped" || existing.type === "bundle") &&
          (incoming.type === "grouped" || incoming.type === "bundle")
        ) {
          const existingBundle = JSON.stringify(existing.bundle || []);
          const incomingBundle = JSON.stringify(incoming.bundle || []);
          if (existingBundle !== incomingBundle) continue;
        }

        foundIndex = i;
        break;
      }

      if (foundIndex >= 0) {
        updateCart(foundIndex, "sum");
      } else {
        const newProducts = [...cartProducts, data];
        addCartProducts(newProducts);
        ls.setJSON("cartProducts", newProducts);
      }
    },
    updateCart: (index, action = "sum") => {
      updateCart(index, action)
    },
    resetCart: () => {
      ls.remove("cartProducts");
      addCartProducts([]);
    },
    removeCartProduct: (product) => {
      const filteredProducts = cartProducts.filter((i, key) => {
        return product !== key;
      });
      addCartProducts(filteredProducts);
      ls.setJSON("cartProducts", filteredProducts);
    },
    cartProducts,
    selectedCategory,
    setSelectedCategory: (category) => {
      setSelectedCategory(category);
    },
    categoriesLoading,
    setCategoriesLoading: (value) => {
      setCategoriesLoading(value);
    },
    productsLoading,
    setProductsLoading: (value) => {
      setProductsLoading(value);
    },
    categories,
    setCategories: (value) => {
      setCategories(value);
    },
    firstRender,
    isFirstRender: (value) => {
      isFirstRender(value);
    },
    products,
    setProducts,
    langRefreshKey,
    refreshLanguage: () => {
      setLangRefreshKey((k) => k + 1);
    },
  };

  function updateCart(index, action = "sum") {
    const newProducts = [...cartProducts];
    const oldProduct = cartProducts[index].product;
    let quantity = oldProduct.quantity;

    if (action === "sum") {
      const maxQty = oldProduct.maxStock || 999;
      if (quantity < maxQty || oldProduct.type === "grouped" || oldProduct.type === "bundle") {
        quantity++;
      }
    }

    if (action === "reduce") {
      quantity--;
      if (quantity <= 0) {
        const filtered = newProducts.filter((_, i) => i !== index);
        addCartProducts(filtered);
        ls.setJSON("cartProducts", filtered);
        return;
      }
    }

    const updatedProduct = { ...oldProduct, quantity };
    newProducts[index] = { product: updatedProduct };
    addCartProducts(newProducts);
    ls.setJSON("cartProducts", newProducts);
  }
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export default {
  Provider,
  Consumer: Context.Consumer,
};
